<template>
  <!-- 离职  -->
  <div class="formBox">
    <!--员工基本信息 -->
    <FormTitle titleText="基本信息" />
    <Form
      ref="formValidate"
      :model="formItem"
      :label-width="150"
      label-position="left"
      style="margin-top:  25px;"
    >
      <div style="margin-bottom: 15px" class="rowAllBox">
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="员工工号">
              <Input disabled placeholder="" v-model="formItem.applyUserId">
              </Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="姓名">
              <Input disabled v-model="formItem.applyName"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="职位">
              <Input disabled v-model="formItem.applyPositionName" />
            </FormItem>
          </Col>
        </Row>
        <!-- <Row type="flex" justify="space-between">
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="公司" >
                    <Input disabled placeholder="" v-model="formItem.apply_orgsname2">
                    </Input>
                  </FormItem>
                </Col>
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="地区">
                    <Input disabled v-model="formItem.apply_orgsname4"></Input>
                  </FormItem>
                </Col>
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="部门">
                    <Input disabled v-model="formItem.apply_orgsname5" />
                  </FormItem>
                </Col>
              </Row> -->
        <div
          class="personnelMatters-button"
          style="margin-top: 30px; margin-bottom: 30px"
        >
          <Checkbox
            disabled="disabled"
            true-value="1"
            false-value="0"
            v-model="formItem.punch_in"
            >补刷卡</Checkbox
          >
          <Checkbox
            disabled="disabled"
            style="margin-left: 100px;"
            true-value="1"
            false-value="0"
            v-model="formItem.card_correction"
            >刷卡修正</Checkbox
          >
        </div>
      </div>
    </Form>
    <div style="margin-top: 15px;">
      <FormTitle titleText="原始刷卡记录" />
      <Form
        ref="formValidate"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <Table border :columns="columns1" :data="data1"> </Table>
      </Form>
    </div>
    <div style="margin-top: 15px;" v-if="formItem.punch_in == '1'">
      <FormTitle titleText="补刷卡" />
      <Form
        ref="formValidate"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <Table border :columns="columns2" :data="data2"> </Table>
      </Form>
    </div>
    <div style="margin-top: 15px;" v-if="formItem.card_correction == '1'">
      <FormTitle titleText="刷卡修正" />
      <Form
        ref="formValidate"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <Table border :columns="columns3" :data="data3"> </Table>
      </Form>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 保存和提交 -->
    <div class="btnRight" style="margin-top: 15px;">
      <Button
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        >退回</Button
      >
      <Button
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        @click="Rejected"
        >驳回</Button
      >
      <Button
        v-if="!getQueryVariable('history')"
        class="applyBtnRight"
        type="primary"
        @click="comfConfig"
        >同意</Button
      >
      <Button class="applyBtnRight" type="primary" @click="returnPage"
        >返回</Button
      >
    </div>
    <Modal
      v-model="showdataRejected"
      :title="$t('请填写驳回意见')"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{ $t("确定") }}</Button>
        <Button @click="cancell2">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <!-- 审批历史 -->
    <FormTitle :titleText="$t('审批历史')" />
    <Table
      border
      :columns="columns6"
      :data="data6"
      slot="content"
      class="titleDistance"
    >
    </Table>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      formInline: {},
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      spinShow: false,
      total: 0,
      rejectMessage: {},
      instanceId: this.getQueryVariable("instanceId"),
      data1: [],
      showdataRejected: false,
      data2: [],
      data3: [],
      data4: [],
      data6: [],
      showAddCard: false,
      showEditCard: false,
      formValidate: {},
      ShuaKaBie: [
        {
          code: 1,
          value: "上班"
        },
        {
          code: 2,
          value: "下班"
        },
        {
          code: 3,
          value: "加班上班"
        },
        {
          code: 4,
          value: "加班下班"
        }
      ]
    };
  },
  computed: {
    ruleValidate() {
      return {
        message: [{ required: true, message: this.$t("请填写驳回意见") + "！" }]
      };
    },
    columns1() {
      return [
        {
          title: "日期",
          key: "card_date",
          align: "center"
        },
        {
          title: "排班",
          key: "sort_class",
          align: "center"
        },
        {
          title: "刷卡别",
          key: "card_type",
          align: "center"
        },
        {
          title: "刷卡时间",
          key: "card_time",
          align: "center"
        }
      ];
    },
    columns2() {
      return [
        {
          title: "日期",
          key: "card_date",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.card_date, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "排班",
          key: "sort_class",
          align: "center"
        },
        {
          title: "补刷卡别",
          key: "card_type",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.ShuaKaBie.filter(
                item => item.code == params.row.card_type
              ).map(res => res.value)
            );
          }
        },
        {
          title: "补刷卡时间",
          key: "card_time",
          align: "center",
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.card_time, "HH:mm"));
          }
        },
        {
          title: "补刷卡原因",
          key: "card_comment",
          align: "center"
        }
      ];
    },
    columns6() {
      return [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ];
    },
    columns3() {
      return [
        {
          title: "日期",
          key: "card_date",
          align: "center"
        },
        {
          title: "排班",
          key: "sort_class",
          align: "center"
        },
        {
          title: "刷卡别",
          key: "card_type",
          align: "center"
        },
        {
          title: "刷卡时间",
          key: "card_time",
          align: "center"
        },
        {
          title: "状态",
          key: "card_status",
          align: "center"
        }
      ];
    }
  },
  created() {
    this.getApprovalInfo();
  },
  methods: {
    Rejected() {
      this.showdataRejected = true;
    },
    getApprovalInfo() {
      let Obj = {
        instanceId: this.getQueryVariable("instanceId")
      };
      axios.post("/Card/selectCardApproval", Obj).then(res => {
        this.formItem = res.approvalCard;
        this.data2 = res.cardPunchInList;
        this.data6 = res.logMap;
      });
    },
    selectEditCard() {
      this.showEditCard = true;
    },
    addBuCard() {
      this.showAddCard = true;
    },
    returnPage() {
      //1审批 0 申请
      if (this.getQueryVariable("taskId")) {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      } else {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      }
    },
    comfConfig() {
      this.$Modal.confirm({
        title: this.$notice("confirmedPass"),
        content: "",
        onOk: () => {
          this.handleSubmit();
        },
        onCancel: () => {}
      });
    },
    handleSubmit() {
      let arr2 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          type: "B17"
        }
      ];
      this.spinShow = true;
      axios.post("/process/execute", arr2).then(res => {
        if (res) {
          this.$Message.info(this.$t("Approval_Completed"));
          this.$router.push(
            "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
          );
          // this.insertCardInfomation()
        }
        this.spinShow = false;
      });
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          this.showdataRejected = false;
          let arr2 = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.spinShow = true;
          axios.post("/process/execute", arr2).then(res => {
            if (res) {
              this.$Message.info(this.$t("Approval_Completed"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
            this.spinShow = false;
          });
        }
      });
    },
    insertCardInfomation() {
      let Obj = {
        apply_serialnumber: this.formItem.apply_serialnumber,
        instanceId: this.instanceId
      };
      axios.post("/Card/insertCardInformation", Obj).then(res => {});
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formBox {
  width: 97%;
  margin: auto;
  background: white;
  padding-bottom: 30px;
  border-radius: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.rowBox {
  line-height: 35px;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}
.rowAllBox {
  width: 97%;
  margin: auto;
}

.width {
  width: 180px;
}
.personnelMatters-button {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/cardApproval.vue